// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LicenseRouteImport } from './routes/license'
import { Route as CrossBorderProcessingRouteImport } from './routes/cross-border-processing'
import { Route as BetaStatusRouteImport } from './routes/beta-status'
import { Route as AiServiceRouteImport } from './routes/ai-service'
import { Route as AcceptableUsePolicyRouteImport } from './routes/acceptable-use-policy'
import { Route as OperatorRouteRouteImport } from './routes/operator/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as HomeRouteRouteImport } from './routes/_home/route'
import { Route as PrinterResumeIdRouteImport } from './routes/printer/$resumeId'
import { Route as PaddleCheckoutRouteImport } from './routes/paddle/checkout'
import { Route as DevAutoPaginationArtifactsRouteImport } from './routes/dev/auto-pagination-artifacts'
import { Route as UsernameSlugRouteImport } from './routes/$username/$slug'
import { Route as BuilderResumeIdRouteRouteImport } from './routes/builder/$resumeId/route'
import { Route as OperatorIndexRouteImport } from './routes/operator/index'
import { Route as OperatorReconciliationRouteImport } from './routes/operator/reconciliation'
import { Route as OperatorOperationsRouteImport } from './routes/operator/operations'
import { Route as OperatorInvitesRouteImport } from './routes/operator/invites'
import { Route as OperatorAiQualityRouteImport } from './routes/operator/ai-quality'
import { Route as OperatorAccessRouteImport } from './routes/operator/access'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthVerify2faBackupRouteImport } from './routes/auth/verify-2fa-backup'
import { Route as AuthVerify2faRouteImport } from './routes/auth/verify-2fa'
import { Route as AuthResumePasswordRouteImport } from './routes/auth/resume-password'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as DevPhase6SafeBoundaryFamilyRouteImport } from './routes/dev/phase6-safe-boundary/$family'
import { Route as BuilderResumeIdIndexRouteImport } from './routes/builder/$resumeId/index'
import { Route as DashboardResumesIndexRouteImport } from './routes/dashboard/resumes/index'
import { Route as DashboardJobSearchIndexRouteImport } from './routes/dashboard/job-search/index'
import { Route as DashboardBillingIndexRouteImport } from './routes/dashboard/billing/index'
import { Route as DashboardSettingsProfileRouteImport } from './routes/dashboard/settings/profile'
import { Route as DashboardSettingsPreferencesRouteImport } from './routes/dashboard/settings/preferences'
import { Route as DashboardSettingsJobSearchRouteImport } from './routes/dashboard/settings/job-search'
import { Route as DashboardSettingsDangerZoneRouteImport } from './routes/dashboard/settings/danger-zone'
import { Route as DashboardSettingsApiKeysRouteImport } from './routes/dashboard/settings/api-keys'
import { Route as DashboardSettingsAiRouteImport } from './routes/dashboard/settings/ai'
import { Route as AuthSupabaseCallbackRouteImport } from './routes/auth/supabase/callback'
import { Route as HomeGuidesIndexRouteImport } from './routes/_home/guides/index'
import { Route as HomeGuidesTailorResumeToJobDescriptionRouteImport } from './routes/_home/guides/tailor-resume-to-job-description'
import { Route as HomeGuidesManageResumeVersionsRouteImport } from './routes/_home/guides/manage-resume-versions'
import { Route as HomeGuidesCheckAiResumeEditsRouteImport } from './routes/_home/guides/check-ai-resume-edits'
import { Route as DashboardSettingsAuthenticationIndexRouteImport } from './routes/dashboard/settings/authentication/index'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LicenseRoute = LicenseRouteImport.update({
            id: '/license',path: '/license',getParentRoute: () => rootRouteImport
          })
const CrossBorderProcessingRoute = CrossBorderProcessingRouteImport.update({
            id: '/cross-border-processing',path: '/cross-border-processing',getParentRoute: () => rootRouteImport
          })
const BetaStatusRoute = BetaStatusRouteImport.update({
            id: '/beta-status',path: '/beta-status',getParentRoute: () => rootRouteImport
          })
const AiServiceRoute = AiServiceRouteImport.update({
            id: '/ai-service',path: '/ai-service',getParentRoute: () => rootRouteImport
          })
const AcceptableUsePolicyRoute = AcceptableUsePolicyRouteImport.update({
            id: '/acceptable-use-policy',path: '/acceptable-use-policy',getParentRoute: () => rootRouteImport
          })
const OperatorRouteRoute = OperatorRouteRouteImport.update({
            id: '/operator',path: '/operator',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const HomeRouteRoute = HomeRouteRouteImport.update({
            id: '/_home',getParentRoute: () => rootRouteImport
          })
const PrinterResumeIdRoute = PrinterResumeIdRouteImport.update({
            id: '/printer/$resumeId',path: '/printer/$resumeId',getParentRoute: () => rootRouteImport
          })
const PaddleCheckoutRoute = PaddleCheckoutRouteImport.update({
            id: '/paddle/checkout',path: '/paddle/checkout',getParentRoute: () => rootRouteImport
          })
const DevAutoPaginationArtifactsRoute = DevAutoPaginationArtifactsRouteImport.update({
            id: '/dev/auto-pagination-artifacts',path: '/dev/auto-pagination-artifacts',getParentRoute: () => rootRouteImport
          })
const UsernameSlugRoute = UsernameSlugRouteImport.update({
            id: '/$username/$slug',path: '/$username/$slug',getParentRoute: () => rootRouteImport
          })
const BuilderResumeIdRouteRoute = BuilderResumeIdRouteRouteImport.update({
            id: '/builder/$resumeId',path: '/builder/$resumeId',getParentRoute: () => rootRouteImport
          })
const OperatorIndexRoute = OperatorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OperatorRouteRoute
          })
const OperatorReconciliationRoute = OperatorReconciliationRouteImport.update({
            id: '/reconciliation',path: '/reconciliation',getParentRoute: () => OperatorRouteRoute
          })
const OperatorOperationsRoute = OperatorOperationsRouteImport.update({
            id: '/operations',path: '/operations',getParentRoute: () => OperatorRouteRoute
          })
const OperatorInvitesRoute = OperatorInvitesRouteImport.update({
            id: '/invites',path: '/invites',getParentRoute: () => OperatorRouteRoute
          })
const OperatorAiQualityRoute = OperatorAiQualityRouteImport.update({
            id: '/ai-quality',path: '/ai-quality',getParentRoute: () => OperatorRouteRoute
          })
const OperatorAccessRoute = OperatorAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => OperatorRouteRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRouteRoute
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthRouteRoute
          })
const AuthVerify2faBackupRoute = AuthVerify2faBackupRouteImport.update({
            id: '/verify-2fa-backup',path: '/verify-2fa-backup',getParentRoute: () => AuthRouteRoute
          })
const AuthVerify2faRoute = AuthVerify2faRouteImport.update({
            id: '/verify-2fa',path: '/verify-2fa',getParentRoute: () => AuthRouteRoute
          })
const AuthResumePasswordRoute = AuthResumePasswordRouteImport.update({
            id: '/resume-password',path: '/resume-password',getParentRoute: () => AuthRouteRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRouteRoute
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AuthRouteRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRouteRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRouteRoute
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeRouteRoute
          })
const DevPhase6SafeBoundaryFamilyRoute = DevPhase6SafeBoundaryFamilyRouteImport.update({
            id: '/dev/phase6-safe-boundary/$family',path: '/dev/phase6-safe-boundary/$family',getParentRoute: () => rootRouteImport
          })
const BuilderResumeIdIndexRoute = BuilderResumeIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BuilderResumeIdRouteRoute
          })
const DashboardResumesIndexRoute = DashboardResumesIndexRouteImport.update({
            id: '/resumes/',path: '/resumes/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardJobSearchIndexRoute = DashboardJobSearchIndexRouteImport.update({
            id: '/job-search/',path: '/job-search/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardBillingIndexRoute = DashboardBillingIndexRouteImport.update({
            id: '/billing/',path: '/billing/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsProfileRoute = DashboardSettingsProfileRouteImport.update({
            id: '/settings/profile',path: '/settings/profile',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsPreferencesRoute = DashboardSettingsPreferencesRouteImport.update({
            id: '/settings/preferences',path: '/settings/preferences',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsJobSearchRoute = DashboardSettingsJobSearchRouteImport.update({
            id: '/settings/job-search',path: '/settings/job-search',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsDangerZoneRoute = DashboardSettingsDangerZoneRouteImport.update({
            id: '/settings/danger-zone',path: '/settings/danger-zone',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsApiKeysRoute = DashboardSettingsApiKeysRouteImport.update({
            id: '/settings/api-keys',path: '/settings/api-keys',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsAiRoute = DashboardSettingsAiRouteImport.update({
            id: '/settings/ai',path: '/settings/ai',getParentRoute: () => DashboardRouteRoute
          })
const AuthSupabaseCallbackRoute = AuthSupabaseCallbackRouteImport.update({
            id: '/supabase/callback',path: '/supabase/callback',getParentRoute: () => AuthRouteRoute
          })
const HomeGuidesIndexRoute = HomeGuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => HomeRouteRoute
          })
const HomeGuidesTailorResumeToJobDescriptionRoute = HomeGuidesTailorResumeToJobDescriptionRouteImport.update({
            id: '/guides/tailor-resume-to-job-description',path: '/guides/tailor-resume-to-job-description',getParentRoute: () => HomeRouteRoute
          })
const HomeGuidesManageResumeVersionsRoute = HomeGuidesManageResumeVersionsRouteImport.update({
            id: '/guides/manage-resume-versions',path: '/guides/manage-resume-versions',getParentRoute: () => HomeRouteRoute
          })
const HomeGuidesCheckAiResumeEditsRoute = HomeGuidesCheckAiResumeEditsRouteImport.update({
            id: '/guides/check-ai-resume-edits',path: '/guides/check-ai-resume-edits',getParentRoute: () => HomeRouteRoute
          })
const DashboardSettingsAuthenticationIndexRoute = DashboardSettingsAuthenticationIndexRouteImport.update({
            id: '/settings/authentication/',path: '/settings/authentication/',getParentRoute: () => DashboardRouteRoute
          })





const HomeRouteRouteChildren = {
  HomeIndexRoute: HomeIndexRoute,HomeGuidesCheckAiResumeEditsRoute: HomeGuidesCheckAiResumeEditsRoute,HomeGuidesManageResumeVersionsRoute: HomeGuidesManageResumeVersionsRoute,HomeGuidesTailorResumeToJobDescriptionRoute: HomeGuidesTailorResumeToJobDescriptionRoute,HomeGuidesIndexRoute: HomeGuidesIndexRoute
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(HomeRouteRouteChildren)




const AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthRegisterRoute: AuthRegisterRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthResumePasswordRoute: AuthResumePasswordRoute,AuthVerify2faRoute: AuthVerify2faRoute,AuthVerify2faBackupRoute: AuthVerify2faBackupRoute,AuthIndexRoute: AuthIndexRoute,AuthSupabaseCallbackRoute: AuthSupabaseCallbackRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,DashboardSettingsAiRoute: DashboardSettingsAiRoute,DashboardSettingsApiKeysRoute: DashboardSettingsApiKeysRoute,DashboardSettingsDangerZoneRoute: DashboardSettingsDangerZoneRoute,DashboardSettingsJobSearchRoute: DashboardSettingsJobSearchRoute,DashboardSettingsPreferencesRoute: DashboardSettingsPreferencesRoute,DashboardSettingsProfileRoute: DashboardSettingsProfileRoute,DashboardBillingIndexRoute: DashboardBillingIndexRoute,DashboardJobSearchIndexRoute: DashboardJobSearchIndexRoute,DashboardResumesIndexRoute: DashboardResumesIndexRoute,DashboardSettingsAuthenticationIndexRoute: DashboardSettingsAuthenticationIndexRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)




const OperatorRouteRouteChildren = {
  OperatorAccessRoute: OperatorAccessRoute,OperatorAiQualityRoute: OperatorAiQualityRoute,OperatorInvitesRoute: OperatorInvitesRoute,OperatorOperationsRoute: OperatorOperationsRoute,OperatorReconciliationRoute: OperatorReconciliationRoute,OperatorIndexRoute: OperatorIndexRoute
}

const OperatorRouteRouteWithChildren = OperatorRouteRoute._addFileChildren(OperatorRouteRouteChildren)




const BuilderResumeIdRouteRouteChildren = {
  BuilderResumeIdIndexRoute: BuilderResumeIdIndexRoute
}

const BuilderResumeIdRouteRouteWithChildren = BuilderResumeIdRouteRoute._addFileChildren(BuilderResumeIdRouteRouteChildren)

const rootRouteChildren = {
  HomeRouteRoute: HomeRouteRouteWithChildren,AuthRouteRoute: AuthRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren,OperatorRouteRoute: OperatorRouteRouteWithChildren,AcceptableUsePolicyRoute: AcceptableUsePolicyRoute,AiServiceRoute: AiServiceRoute,BetaStatusRoute: BetaStatusRoute,CrossBorderProcessingRoute: CrossBorderProcessingRoute,LicenseRoute: LicenseRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundPolicyRoute: RefundPolicyRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,BuilderResumeIdRouteRoute: BuilderResumeIdRouteRouteWithChildren,UsernameSlugRoute: UsernameSlugRoute,DevAutoPaginationArtifactsRoute: DevAutoPaginationArtifactsRoute,PaddleCheckoutRoute: PaddleCheckoutRoute,PrinterResumeIdRoute: PrinterResumeIdRoute,DevPhase6SafeBoundaryFamilyRoute: DevPhase6SafeBoundaryFamilyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)